import Vue from 'vue';

const state = {
	tagList: null,
	tagList_loading: false
};

const getters = {
	tagList: state => {
		return state.tagList;
	},
    employeeTagList: state => {
		return state.tagList.filter(x => x.references.includes('employee'));
	}
};

const actions = {
	getTagList({ commit, rootState }) {
		console.log('Retrieving Tag List...');
		commit('GET_TAGLIST_PENDING');
		return Vue.axios
			.get(`/api/${rootState.tenantId}/taglist`)
			.then(response => {
				commit('GET_TAGLIST_SUCCESS', response.data);
			})
			.catch(error => {
				commit('GET_TAGLIST_FAILURE', error);
			});
	},
};

const mutations = {
	GET_TAGLIST_PENDING(state) {
		state.tagList_loading = true;
	},
	GET_TAGLIST_SUCCESS(state, data) {
		state.tagList_loading = false;
		state.tagList = data;
	},
	GET_TAGLIST_FAILURE(state, error) {
		state.tagList_loading = false;
		console.log(error);
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
